import React, { useState, useEffect, useContext } from "react";
import useToastContext from "hooks/useToastContext";
import { useForm } from "react-hook-form";
import { apiPost, apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import { useNavigate } from "react-router-dom";
import AuthContext from "context/AuthContext";
import Select from "react-select";
import ErrorMessage from "components/ErrorMessage";
import OTextArea from "components/reusable/OTextArea";
import helpers from "../../utils/helpers";

const AddNotification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const notification = useToastContext();
  const [companyList, setCompanyList] = useState([]);
  const [referenceLink, setReferenceLink] = useState([]);
  const [isReferenceError, setIsReferenceError] = useState(false);
  const [isCompanyError] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const handleRememberMe = (e) => {
    setRememberMe(e.target.checked);
  };
  const { updatePageName } = useContext(AuthContext);

  const onSubmit = async (data) => {
    try {
      const companyData = helpers?.ternaryCondition(rememberMe, "allCompanies", "specificCompany");
      let link = [];
      if (referenceLink.length > 0) {
        link = referenceLink?.map((item) => item?.value);
      }
      const payload = {
        title: data?.title,
        description: data?.description,
        sendTo: companyData,
        companies: link,
      };
      const res = await apiPost(apiPath.notificationAdd, payload);
      if (res?.data?.success) {
        navigate("/notification_manager");
        notification.success(res.data?.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  useEffect(() => {
    updatePageName(t("ADD_NOTIFICATION"));
  }, []);

  const getCompanyList = async () => {
    try {
      const res = await apiGet(apiPath.allCompany, {});
      setCompanyList(res?.data?.results);
    } catch (error) {
      console.log("error:", error);
    }
  };
  const referenceLinkOptions = companyList?.map((item) => {
    return { label: item?.name, value: item?._id };
  });

  useEffect(() => {
    getCompanyList();
  }, []);

  const onError = () => {
    if (rememberMe) {
      setIsReferenceError(false);
    } else {
      if (referenceLink.length === 0) {
        setIsReferenceError(true);
        return;
      } else {
        setIsReferenceError(false);
      }
    }
  };
  return (
    <>
      <div className="relative p-6 flex-auto">
        <div className="grid sm:grid-cols-1 md:grid-cols-3">
          <div className="px-2 col-span-1">
            <OInputField
              wrapperClassName="relative z-0 mb-6 w-full group"
              name="title"
              inputLabel={
                <>
                  {t("TITLE")}
                  <span className="text-red-500">*</span>
                </>
              }
              type="text"
              autoFocus
              register={register("title", formValidation["title"])}
              errors={errors}
            />
          </div>
          <div className="px-2 col-span-1.5">
            <Select
              isMulti
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  padding: "9px 4px",
                  borderRadius: "0.5rem",
                  border: "2px solid rgb(223 223 223);",
                }),
              }}
              name="referenceLink"
              isDisabled={rememberMe}
              options={referenceLinkOptions}
              placeholder="Select company"
              className="basic-multi-select"
              classNamePrefix="select"
              value={referenceLink}
              onChange={(item) => {
                setReferenceLink(item);
                setIsReferenceError(false);
              }}
            />
            {isReferenceError && <ErrorMessage message="Please select company." />}
          </div>
          <div className={helpers?.ternaryCondition(referenceLink.length > 0, "px-2 col-span-0.5 cursor-not-allowed", "px-2 col-span-0.5")}>
            <h6>Send to</h6>
            <div className={helpers?.ternaryCondition(referenceLink.length > 0, "flex items-center h-5 mt-2 opacity-50 p-2 ", "flex items-center h-5 mt-2")}>
              <div>
                <input
                  id="remember"
                  type="checkbox"
                  disabled={referenceLink.length > 0}
                  checked={helpers?.ternaryCondition(rememberMe, true, false)}
                  className="input-check w-4 h-4 bg-gray-50 rounded border border-[#DFDFDF]  focus:ring-3 focus:ring-[#DFDFDF] dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-[#DFDFDF] dark:ring-offset-gray-800"
                  onChange={(e) => {
                    handleRememberMe(e);
                    setIsReferenceError(false);
                  }}
                />
                {isCompanyError && <ErrorMessage message="please select all company." />}
              </div>
              <label htmlFor="remember" className="ml-2 text-sm text-black dark:text-gray-300 ">
                All Companies
              </label>
            </div>
          </div>
          <div className="px-2 col-span-3">
            <OTextArea
              wrapperClassName="relative z-0 w-full group"
              name="description"
              inputLabel={
                <>
                  {t("DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </>
              }
              type="textarea"
              register={register("description", formValidation["description"])}
              errors={errors}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
        <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => navigate("/notification_manager")}>
          {t("O_BACK")}
        </button>

        <button
          className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
          type="submit"
          onClick={handleSubmit(onSubmit, onError)}
        >
          {t("O_ADD")}
        </button>
      </div>
    </>
  );
};

export default AddNotification;
